var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeClaude3Opus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 5.14286C36 2.30143 33.6986 0 30.8571 0H5.14286C2.30143 0 0 2.30143 0 5.14286V30.8571C0 33.6986 2.30143 36 5.14286 36H30.8571C33.6986 36 36 33.6986 36 30.8571V5.14286Z",
    fill: "#F0EFEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19423_52763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2304 11H19.2109L24.7174 24.913H27.737L22.2304 11ZM13.5065 11L8 24.913H11.0791L12.2052 21.9913H17.9661L19.0922 24.913H22.1713L16.6648 11H13.5065ZM13.2013 19.4074L15.0857 14.5178L16.97 19.4074H13.2013Z",
    fill: "#101828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19423_52763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.913,
    fill: "white",
    transform: "translate(8 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeClaude3Opus);
export default __webpack_public_path__ + "static/media/type=Claude 3 Opus.dcd72df86db536e37b376307b36c267e.svg";
export { ForwardRef as ReactComponent };